import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/top_ups',
  component: Management,
  redirect: '/top_ups/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/top_ups/List'),
      meta: {
        auth: Auth.listTopUps
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/top_ups/ListTable'),
          meta: {
            auth: Auth.listTopUps,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
